exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".time-ago{display:inline-block;cursor:default}", "", {"version":3,"sources":["/divvit-app/client/components/TimeAgo/client/components/TimeAgo/style.styl","/divvit-app/client/components/TimeAgo/style.styl"],"names":[],"mappings":"AAAA,UACE,qBAAA,cACA,CCCD","file":"style.styl","sourcesContent":[".time-ago\n  display: inline-block\n  cursor: default\n",".time-ago {\n  display: inline-block;\n  cursor: default;\n}\n/*# sourceMappingURL=client/components/TimeAgo/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/components/TimeAgo/style.styl
// module id = 574
// module chunks = 0